import { gql } from 'graphql-tag';
import { ORDER_FRAGMENT } from '../fragments';
import { CUSTOMER_FRAGMENT } from '../fragments/customer';

/**
 * 获取待评价列表
 */
export const fetchAvailableOrdersToReviewDocument = gql`
  query availableOrdersToReview($options: OrderListOptions) {
    availableOrdersToReview(options: $options) {
      items {
        ...Order
      }
      totalItems
    }
  }
  ${ORDER_FRAGMENT}
`;

/**
 * 获取已评价列表
 */
export const fetchReviewsProductDocument = gql`
  query myReviewsProduct($options: ReviewProductListOptions) {
    myReviewsProduct(options: $options) {
      items {
        id
        title
        createdAt
        updatedAt
        description
        stars
        reviewImgs
        product {
          id
          name
          description
          enabled
          featuredAsset {
            source
          }
          customFields {
            price
            markingPrice
            unit
            limitType
            limitCount
            putOnSaleType
            putOnSaleTime
          }
        }
        order {
          ...Order
        }
        customerName
        customerNameIsPublic
        automaticReview
        shopReply
        replyDate
      }
      totalItems
    }
  }
  ${ORDER_FRAGMENT}
`;

/**
 * 创建评价
 */
export const fetchCreateReviewProductDocument = gql`
  mutation createReviewProduct($input: CreateReviewProductInput!) {
    createReviewProduct(input: $input) {
      id
    }
  }
`;

/**
 * 根据商品id获取评论数据
 */
export const fetchReviewsByProductIdDocument = gql`
  query reviews($productId: ID!, $options: ReviewProductListOptions) {
    reviews(productId: $productId, options: $options) {
      items {
        id
        title
        createdAt
        updatedAt
        description
        stars
        includePic
        reviewImgs
        customer {
          ...Customer
        }
        product {
          id
          optionGroups {
            id
            code
            name
            customFields {
              priority
            }
            options {
              id
              code
              name
              customFields {
                priority
              }
            }
          }
          variants {
            id
            name
            featuredAsset {
              source
            }
            options {
              id
              code
              name
              group {
                id
                code
                name
              }
            }
          }
        }
        customerName
        customerNameIsPublic
        automaticReview
        shopReply
        replyDate
      }
      totalItems
    }
  }
  ${CUSTOMER_FRAGMENT}
`;
